import { Button, Icon, Typography } from '@/components';
import { cn } from '@/utils/styles';

export type CollapsableHeaderProps = {
  readonly title: string;
  readonly description?: string;
  readonly isExpanded: boolean;
  readonly action?: {
    readonly title: string;
    readonly onClick?: () => void;
  };
  readonly onToggle?: () => void;
  readonly weight?: 'normal' | 'semibold';
  readonly icons?: React.ReactNode;
  readonly headClasses?: string;
  readonly childrenHeader?: React.ReactNode;
};

export function CollapsableHeader({
  title,
  description,
  isExpanded,
  action,
  onToggle,
  weight,
  icons,
  headClasses,
  childrenHeader,
}: CollapsableHeaderProps) {
  return (
    <div className="flex cursor-pointer items-center justify-between gap-4 p-6" onClick={() => onToggle?.()}>
      <div className="space-y-1">
        <div className="flex content-center">
          {icons}
          <Typography
            as="h4"
            size="title"
            color="primary"
            weight={weight}
            className={`${headClasses ?? ''} self-center uppercase`}
          >
            {title}
          </Typography>
        </div>
        <Typography as="p" size="body-3" color="secondary" weight="normal">
          {description}
        </Typography>
        {childrenHeader}
      </div>

      <div className="inline-flex items-center justify-start gap-4">
        {action ? (
          <Button
            size="md"
            color="neutral"
            icon="edit"
            onClick={(e) => {
              e.stopPropagation();
              action.onClick?.();
            }}
            disabled={!action.onClick}
          >
            {action.title}
          </Button>
        ) : null}

        <button
          type="button"
          className="bg-base-white hover:bg-neutral-25 flex h-10 w-10 items-center justify-center rounded-full border border-neutral-50 transition hover:shadow-xs"
          onClick={(e) => {
            e.stopPropagation();
            onToggle?.();
          }}
        >
          <Icon
            name="chevron-left"
            className={cn('text-base-primary h-6 w-6 transition', isExpanded ? 'rotate-90' : '-rotate-90')}
          />
        </button>
      </div>
    </div>
  );
}
